export default __webpack_public_path__ + "static/media/up.27d25fa6.svg";